/**
 * 휴가 현황 데이터 파싱 유틸
 *
 * @param {string} raw
 *  서버에서 내려오는 휴가 현황 문자열
 *  예시: "14|0|0|11|0|11|0|0|0|0|14"
 *
 * @returns {Object}
 *  generated : 발생 휴가 정보
 *  used      : 사용 휴가 정보
 *  remaining : 잔여 휴가 정보
 */
export function parseVacationStatus(raw) {
  if (!raw || raw === 'NO_DATA') {
    return {
      generated: { beginningOfYear: 0, afterRevision: 0, currentYearAdditional: 0, total: 0 },
      used: { previousYearPreUsed: 0, currentYearUsed: 0, total: 0 },
      remaining: { afterRevision: 0, total: 0 },
    };
  }

  // "|" 기준으로 분리 후 숫자로 변환
  // 서버에서 음수 값이 내려올 경우 그대로 유지됨
  const parts = raw.split('|').map(Number);

  const beginningOfYear = parts[0] || 0;
  const afterRevision = parts[3] || 0;
  const currentYearAdditional = parts[4] || 0;

  const previousYearPreUsed = parts[5] || 0;
  const currentYearUsed = parts[6] || 0;

  const remainingAfterRevision = parts[9] || 0;
  const totalRemaining = parts[10] || 0;

  return {
    generated: {
      beginningOfYear,
      afterRevision,
      currentYearAdditional,
      total: beginningOfYear + afterRevision + currentYearAdditional,
    },
    used: {
      previousYearPreUsed,
      currentYearUsed,
      total: previousYearPreUsed + currentYearUsed,
    },
    remaining: {
      afterRevision: remainingAfterRevision,
      total: totalRemaining,
    },
  };
}
